import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { PMemoEditorComponent } from './../../primeng/p-memo-editor/p-memo-editor.component';

@Component({
  selector: 'app-memo-editor',
  templateUrl: './memo-editor.component.html',
  styleUrls: ['./memo-editor.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MemoEditorComponent), multi: true}
  ],
  standalone: true,
  imports: [
    // EditorModule,
    FormsModule,
    PMemoEditorComponent
  ]
})
export class MemoEditorComponent implements OnInit {

  @Input() style: any;

  set controlValue(value: string) {
    if (this._controlValue !== value) {
      this._controlValue = value;
      this.onTouched();
      this.onChange(value);
    }
  }
  get controlValue(): string {
    return this._controlValue;
  }
  private _controlValue: string;

  ngControl: NgControl;
  onChange: (_: any) => void;
  onTouched: () => void;

  constructor(private _inj: Injector) { }

  ngOnInit(): void {
    this.ngControl = this._inj.get(NgControl);
  }

  writeValue(value: string): void {
    this._controlValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
